module.exports = __webpack_public_path__ + "slide4-steps.19e2b6e2e71b4477d7bd815886f84221.hashedasset.svg";